/**
 * Calculates the total years of experience from a start date to the current date.
 * @param {Object} startDate - The start date object
 * @param {number} startDate.year - The year the experience started
 * @param {number} [startDate.month=0] - The month the experience started (0-11), defaults to 0
 * @returns {number} The total years of experience, rounded up if more than 6 months have passed in the current year
 */
export const calculateExperience = (startDate) => {
  const now = new Date();
  const years = now.getFullYear() - startDate.year;
  const months = now.getMonth() - (startDate.month || 0);
  return months > 6 ? years + 1 : years;
};
